import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ModalContainer, ModalRoute } from "react-router-modal";
import Home from "./Home";
import Article from "./Article";
import ChapterArticle from "./ChapterArticle";
import BottomBar from "../components/BottomBar/BottomBar";
import ScrollMemory from "../common/ScrollMemory";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import pageStyles from "../common/Page.module.less";
import Media from "react-media";
import FooterScript from "../components/FooterScript/FooterScript";

import "../common/react-router-modal.css";

export default function App() {
    const [menuOpen, setMenuOpen] = useState<boolean>();

    return (
        <Router basename={process.env.PUBLIC_URL}>
            <ScrollMemory elementSelector=".react-router-modal__modal"/>

            <div className={pageStyles.Page}>
                                
                <nav className={pageStyles["Page-nav"]}>
                    <div className={[pageStyles["Page-navInner"], menuOpen ? pageStyles["Page--menuOpen"] : null].join(" ")}>
                        <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)}/>

                        <button
                            title="Menu"
                            onClick={() => setMenuOpen(!menuOpen)}
                            className={pageStyles["Page-navButton"]}
                        >
                            <img src={menuOpen ? process.env.PUBLIC_URL + "/assets/close.svg" : process.env.PUBLIC_URL + "/assets/menu.svg"} alt="Menu" />
                        </button>
                    </div>
                </nav>
                <main className={pageStyles["Page-main"]} onClick={() => setMenuOpen(false)}>
                    <Route path="/">
                        <Switch>
                            <Route exact path="/:slug" component={Article} />
                            <Route path="/" component={Home} />
                        </Switch>
                    </Route>

                    <Footer />
                </main>
            </div>

            <Media query={{ maxWidth: 767 }} render={() => <BottomBar onMenuOpen={() => setMenuOpen(!menuOpen)} onMenuClose={() => setMenuOpen(false)} />} />

            <ModalRoute component={ChapterArticle} path="/chapter/:slug" parentPath="/" />

            <ModalContainer outDelay={500} />
            <FooterScript />
        </Router>
    );
}
